<template>
  <div>
    <v-col class="d-flex ml-auto" cols="4" sm="4">
      <v-select v-model="yearSelected" label="Selecione" :items="years" dense outlined></v-select>
    </v-col>
    <highcharts v-if="loaded" :options="chartOptions" />
  </div>
</template>

<script>
  import GraficosService from '@/services/GraficosService';
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  import dayjs from 'dayjs';
  More(Highcharts);

  export default {
    name: 'SaldoAicLine',
    data() {
      return {
        yearSelected: null,
        fireDataAic: []
      };
    },
    computed: {
      loaded: function () {
        return this.fireDataAic && this.fireDataAic.length != 0;
      },
      chartOptions: function () {
        return {
          chart: {
            zoomType: 'xy',
            style: {
              fontFamily: 'muli'
            },
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: '',
            align: 'center'
          },
          xAxis: [
            {
              categories: this.categories,
              crosshair: true
            }
          ],
          yAxis: [
            {
              // Primary yAxis
              gridLineWidth: 0,
              title: {
                text: 'MM R$',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              labels: {
                formatter: function () {
                  return Highcharts.numberFormat(this.value / 1000000, 0, ',');
                },
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              }
            }
          ],
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          },
          series: [
            {
              name: 'Saldo AIC',
              type: 'spline',
              yAxis: 0,
              data: this.aicData,
              tooltip: {
                valuePrefix: 'R$ '
              },
              color: '#F66448'
            }
          ]
        };
      },
      categories: function () {
        var array = [];
        var aux = this.fireDataAic;

        if (this.yearSelected && this.yearSelected !== 'LTM') {
          aux = aux.filter((item) => dayjs(item.DATA_BASE).format('YYYY') === this.yearSelected);
        }

        aux.forEach(function (element) {
          array.push(dayjs(element.DATA_BASE).format('MM/YYYY'));
        });

        return array.slice(-13);
      },
      years: function () {
        var array = [];
        var aux = this.fireDataAic;

        aux.forEach(function (element, index) {
          array[index] = dayjs(element.DATA_BASE).format('YYYY');
        });

        array.push('LTM');

        return array.reverse();
      },
      aicData: function () {
        var array = [];
        var aux = Object.values(this.fireDataAic);
        var filtroDataAic = [];

        for (let index in this.categories) {
          filtroDataAic.push(aux.filter((item) => dayjs(item.DATA_BASE).format('MM/YYYY') === this.categories[index]));
        }

        for (let index in filtroDataAic) {
          array.push(parseFloat(filtroDataAic[index][0].VALOR).toFixed(2));
        }

        return array.map((value) => parseFloat(value));
      }
    },
    mounted() {
      this.getDadosDashboard();
    },
    methods: {
      getDadosDashboard() {
        return GraficosService.getDadosByNome('Firebase - Saldo AIC LTM')
          .then(({ data }) => {
            this.fireDataAic = Object.values(data.data);
          })
          .catch((err) => {
            this.$toast.error('Erro ao buscar os dados do Dashboard', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      }
    }
  };
</script>
